<h2 mat-dialog-title class="font-medium dialog-title d-flex align-items-center justify-content-between">
  {{ data.title || 'Confirmación' }}

  <!-- botón cerrar -->
  <button mat-icon-button  disableRipple class="close-btn close-btn-custom " (click)="cancel()" aria-label="Cerrar">
    <mat-icon width ="24px">close</mat-icon>
  </button>
</h2>

<mat-dialog-content>
  <span [innerHTML]="data.message"></span>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">{{ data.cancelText || 'Cancelar' }}</button>
  <button mat-raised-button [color]="data.confirmColor || 'warn'" (click)="confirm()">
    {{ data.confirmText || 'Eliminar' }}
  </button>
</mat-dialog-actions>
